import { memo } from 'react'
import { DevToolsPopup } from './DevToolsPopup'
import { DevActionsGroup, TinyButton } from './styles'
import { useDispatch } from 'react-redux'
import { updateUserToken } from '../../store/account/actions'

export const SessionControl = memo(() => {
  const dispatch = useDispatch()
  return (
    <DevToolsPopup
      popup={
        <DevActionsGroup>
          <TinyButton
            onClick={() =>
              dispatch(
                updateUserToken(
                  'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ1.eyJzdWIiOiIweDExMTE2MDliNTVCYWVBMEFEODFGM0VjNjAyQTQ5MDI3N0NDMjY2MGQiLCJpc3MiOiJJU1NVRVIiLCJleHAiOjE3MDc0NDU1NDl9.xM7xK0JzrE7ffbWE5DmJYxAB8fQo13oTbFvUW_oipyU',
                ),
              )
            }
          >
            Expire Access-Token
          </TinyButton>
          <TinyButton onClick={() => dispatch(updateUserToken(''))}>
            Clear Access-Token
          </TinyButton>
        </DevActionsGroup>
      }
    >
      <TinyButton>Session Control</TinyButton>
    </DevToolsPopup>
  )
})
